<template>
  <div class="login" id="homebig">
    <div class="mainFrame">
      <div class="bt">
        <img style="width: 49.375rem;height: 6.6875rem;" src="../../../static/images/home/pic_title.png" />
      </div>
      <div class="znr">
        <div class="znr_head">
          <div class="ts">
            <div class="ts_dz">{{local.city}}</div>
            <div class="ts_tq">
              <img class="tq_img" :src="tqsrc" />
              <span class="tq_txt">{{local.temperature}}</span>
            </div>
            <div class="ts_sj">{{sj}}</div>
          </div>
          <div class="xtrk" @click="xtrkClick()">
            <span class="xtrk_txt">进入系统</span>
            <img class="xtrk_img" src="../../../static/images/home/jt.png" />
          </div>
        </div>
        <div class="znr_body">
          <div class="body_head">
            <div class="header_line">
              <span class="line_left">&nbsp;</span>
              <span class="line_right">&nbsp;</span>
              <img class="head_img" src="../../../static/images/home/icon_hyzj.png" />
              <div class="txt">
                <span class="txt_title">会员总计（个）</span>
                <span class="sl">{{hydws+hygrs}}</span>
              </div>
            </div>
            <div class="header_line">
              <span class="line_left">&nbsp;</span>
              <span class="line_right">&nbsp;</span>
              <img class="head_img" src="../../../static/images/home/icon_dwhy.png" />
              <div class="txt">
                <span class="txt_title">单位会员（家）</span>
                <span class="sl">{{hydws}}</span>
              </div>
            </div>
            <div class="header_line">
              <span class="line_left">&nbsp;</span>
              <span class="line_right">&nbsp;</span>
              <img class="head_img" src="../../../static/images/home/icon_grhy.png" />
              <div class="txt">
                <span class="txt_title">个人会员（个）</span>
                <span class="sl">{{hygrs}}</span>
              </div>
            </div>
            <div class="header_line">
              <span class="line_left">&nbsp;</span>
              <span class="line_right">&nbsp;</span>
              <img class="head_img" src="../../../static/images/home/icon_zxtg.png" />
              <div class="txt">
                <span class="txt_title">在线投稿（篇）</span>
                <span class="sl">{{zxtgs}}</span>
              </div>
            </div>
          </div>
          <div class="body_left">
            <div class="left_one" style="cursor: pointer;" @click="showXszeDialog()">
              <span class="line_left">&nbsp;</span>
              <span class="line_right">&nbsp;</span>
              <div class="left_one_div">
                <div class="left_one_head">会员单位营业总额排行（TOP7）</div>
                <div class="left_one_nr_bt">
                  <div class="left_one_pm">排名</div>
                  <div class="left_one_dw">单位</div>
                  <div class="left_one_xsze">{{nd}}年营业总额</div>
                </div>
                <ul>
                  <li v-for="(item,index) in topdata" class="left_one_nr">
                    <div class="left_one_pm">{{index+1}}</div>
                    <div class="left_one_dw">{{item.dwmc}}</div>
                    <div class="left_one_xsze">{{item.ayear}}</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="left_two">
              <span class="line_left">&nbsp;</span>
              <span class="line_right">&nbsp;</span>
              <div class="left_one_div">
                <div class="left_two_left">
                  <div class="echartsBox">
                    <div id="pieone" class="pieone"></div>
                  </div>
                </div>
                <div class="left_two_right">
                  <div class="left_two_div">
                    <div class="progress_div">
                      <span class="progress_bt">本周</span>
                      <div class="progress_zj">
                        <el-progress :percentage="hyweek" :format="format1"></el-progress>
                      </div>

                    </div>
                    <div class="progress_div">
                      <span class="progress_bt">本月</span>
                      <div class="progress_zj">
                        <el-progress :percentage="hymonth" :format="format2"></el-progress>
                      </div>

                    </div>
                    <div class="progress_div">
                      <span class="progress_bt">本年</span>
                      <div class="progress_zj">
                        <el-progress :percentage="hyyear" :format="format3"></el-progress>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="body_right">
            <div class="right_one" style="cursor: pointer;" @click="showHyDialog()">
              <span class="line_left">&nbsp;</span>
              <span class="line_right">&nbsp;</span>
              <div class="left_one_div">
                <div class="echartsBox">
                  <div id="zhu" class="zhu"></div>
                </div>
              </div>
            </div>
            <div class="right_two">
              <span class="line_left">&nbsp;</span>
              <span class="line_right">&nbsp;</span>
              <div class="left_one_div">
                <div class="echartsBox">
                  <div id="pie5" class="pie5"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="body_center">
            <div class="china_map_box">
              <div id="regionCharts" class="china_map"></div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title="消防协会会员单位近三年销售额统计表" :visible.sync="xszeDialogVisible" :close-on-click-modal="false"
        v-loading="this.xszeDialogLoading" element-loading-text="加载中">
        <el-table border id="table"
          :data="xszeDialogTableData.slice((xszeDialogCurrentPage-1)*xszeDialogPageSize,xszeDialogCurrentPage*xszeDialogPageSize)"
          class="tableStyle" style="width:100%;" :height="xszeDialogTableheight" :row-style="rowStyle"
          v-loading="this.xszeDialogLoading" element-loading-text="加载中">
          <el-table-column type="index" show-overflow-tooltip label="序号" width="65px" align="center"></el-table-column>
          <el-table-column prop="dwmc" show-overflow-tooltip label="单位名称" min-width="40%" align="center">
          </el-table-column>
          <el-table-column prop="ayear" show-overflow-tooltip :label="nda" min-width="20%" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.ayear != null" v-text="scope.row.ayear"></span>
              <span v-else v-text="0"></span>
            </template>
          </el-table-column>
          <el-table-column prop="byear" show-overflow-tooltip :label="ndb" min-width="20%" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.byear != null" v-text="scope.row.byear"></span>
              <span v-else v-text="0"></span>
            </template>
          </el-table-column>
          <el-table-column prop="cyear" show-overflow-tooltip :label="ndc" min-width="20%" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.cyear != null" v-text="scope.row.cyear"></span>
              <span v-else v-text="0"></span>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
          <el-col :span="18">
            <el-pagination @size-change="dialogPageSizeChange" @current-change="dialogCurrentPageChange"
              :current-page="this.xszeDialogCurrentPage" :page-sizes="[this.xszeDialogPageSize]"
              :page-size="this.xszeDialogPageSize" layout="total, sizes, prev, pager, next, jumper"
              :total=parseInt(this.xszeDialogTotal)>
            </el-pagination>
          </el-col>
        </el-row>
      </el-dialog>

      <el-dialog title="按行业分类单位会员数量统计表" :visible.sync="hyDialogVisible" :close-on-click-modal="false">
        <el-table border id="table" row-key="codeValue" :data="hyDialogTableData"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}" class="tableStyle"
          v-loading="this.hyDialogLoading" element-loading-text="加载中">
          <el-table-column type="index" show-overflow-tooltip label="序号" width="65" align="center">
          </el-table-column>
          <el-table-column prop="codeName" show-overflow-tooltip label="行业分类" min-width="40%" align="left">
            <template slot-scope="scope">
              <span style="line-height: 40px;" v-text="scope.row.codeName"></span>
            </template>
          </el-table-column>
          <el-table-column prop="hysl" show-overflow-tooltip label="会员数量" min-width="20%" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="showHydwDialog(scope.row.codeValue)">{{scope.row.hysl}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <div>
        <el-dialog title="会员列表" :visible.sync="hydwdtDialogVisible" :close-on-click-modal="false"
          v-loading="this.hydwdtDialogLoading" element-loading-text="加载中">
          <el-row>
            <el-col :span="12" class="searchInline">
              <label class="el-form-item__label searchLabel" style="width:100px;">会员类型</label>
              <!-- <label class="el-form-item__label searchLabel" style="width:100px;">会员类型</label> -->
              <el-radio-group v-model="hylx" size="small" auto-complete="off" style="width: 100%;">
                <el-radio :label="item.codeValue" :key="item.codeValue" v-for="(item,index) in hylxData"
                  style="vertical-align: middle;line-height: 30px;">{{item.codeName}}</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <div v-if="hylx == '10'">
            <el-table border id="table"
              :data="hydwdtDialogTableData.slice((hydwdtDialogCurrentPage-1)*hydwdtDialogPageSize,hydwdtDialogCurrentPage*hydwdtDialogPageSize)"
              class="tableStyle" style="width:100%;" :height="hydwdtDialogTableheight" :row-style="rowStyle"
              v-loading="this.hydwdtDialogLoading" element-loading-text="加载中">
              <el-table-column type="index" show-overflow-tooltip label="序号" width="65px" align="center">
              </el-table-column>
              <el-table-column prop="dwmc" show-overflow-tooltip label="单位名称" min-width="40%" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="dwDetail(scope.row.dwid)">{{scope.row.dwmc}}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="dwflmc" show-overflow-tooltip label="单位分类" min-width="40%" align="center">
              </el-table-column>
              <el-table-column prop="xsze" show-overflow-tooltip label="上一年度营业总额(万元)" min-width="40%" align="center">
              </el-table-column>
            </el-table>
            <el-row type="flex" justify="end">
              <el-col :span="18">
                <el-pagination @size-change="dialoghydwdtPageSizeChange" @current-change="dialoghydwdtCurrentPageChange"
                  :current-page="this.hydwdtDialogCurrentPage" :page-sizes="[this.hydwdtDialogPageSize]"
                  :page-size="this.hydwdtDialogPageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="parseInt(this.hydwdtDialogTotal)">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
          <div v-if="hylx == '20'">
            <el-table border id="table"
              :data="hygrdtDialogTableData.slice((hygrdtDialogCurrentPage-1)*hygrdtDialogPageSize,hygrdtDialogCurrentPage*hygrdtDialogPageSize)"
              class="tableStyle" style="width:100%;" :height="hygrdtDialogTableheight" :row-style="rowStyle"
              v-loading="this.hygrdtDialogLoading" element-loading-text="加载中">
              <el-table-column type="index" show-overflow-tooltip label="序号" width="65px" align="center">
              </el-table-column>
              <el-table-column prop="dwmc" show-overflow-tooltip label="姓名" min-width="40%" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="grDetail(scope.row.dwid)">{{scope.row.dwmc}}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex" justify="end">
              <el-col :span="18">
                <el-pagination @size-change="dialoghygrdtPageSizeChange" @current-change="dialoghygrdtCurrentPageChange"
                  :current-page="this.hygrdtDialogCurrentPage" :page-sizes="[this.hygrdtDialogPageSize]"
                  :page-size="this.hygrdtDialogPageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="parseInt(this.hygrdtDialogTotal)">
                </el-pagination>
              </el-col>
            </el-row>
          </div>

        </el-dialog>
      </div>

      <div>
        <el-dialog title="单位列表" :visible.sync="hydwDialogVisible" :close-on-click-modal="false"
          v-loading="this.hydwDialogLoading" element-loading-text="加载中">
          <el-table border id="table"
            :data="hydwDialogTableData.slice((hydwDialogCurrentPage-1)*hydwDialogPageSize,hydwDialogCurrentPage*hydwDialogPageSize)"
            class="tableStyle" style="width:100%;" :height="hydwDialogTableheight" :row-style="rowStyle"
            v-loading="this.hydwDialogLoading" element-loading-text="加载中">
            <el-table-column type="index" show-overflow-tooltip label="序号" width="65px" align="center">
            </el-table-column>
            <el-table-column prop="dwmc" show-overflow-tooltip label="单位名称" min-width="40%" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="dwDetail(scope.row.dwid)">{{scope.row.dwmc}}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="scl" show-overflow-tooltip label="生产量" min-width="15%" align="center">
            </el-table-column>
            <el-table-column prop="xsl" show-overflow-tooltip label="销售量" min-width="15%" align="center">
            </el-table-column>
            <el-table-column prop="xse" show-overflow-tooltip label="销售额" min-width="15%" align="center">
            </el-table-column>
          </el-table>
          <el-row type="flex" justify="end">
            <el-col :span="18">
              <el-pagination @size-change="dialoghydwPageSizeChange" @current-change="dialoghydwCurrentPageChange"
                :current-page="this.hydwDialogCurrentPage" :page-sizes="[this.hydwDialogPageSize]"
                :page-size="this.hydwDialogPageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="parseInt(this.hydwDialogTotal)">
              </el-pagination>
            </el-col>
          </el-row>
        </el-dialog>
      </div>

    </div>
  </div>
</template>

<script>
  // 引入基本模板
  let echarts = require('echarts/lib/echarts')
  // 引入柱状图组件
  require('echarts/lib/chart/bar')
  // 引入饼状图
  require('echarts/lib/chart/pie')
  // 引入主题
  import 'echarts/theme/infographic.js'
  import 'echarts/map/js/china.js'
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')
  require('echarts/lib/component/legend')
  import Calendar from 'vue-calendar-component';
  // import axiosH from "axios";




  export default {
    name: 'homebig',
    components: {
      Calendar,
    },
    data() {
      return {
        hydws: "0", //单位会员数
        hygrs: "0", //个人会员数
        zxtgs: "0", //在线投稿数
        hydwxz: [], //单位会员新增情况数据统计
        hygrxz: [], //个人会员新增情况数据统计
        topdata: [], //top7排行数据
        nd: "",
        hydata: [], //行业营业总额
        lmdata: [], //按照栏目投稿量占比
        hyfbdata: [],
        hyweek: 0, //会员新增本周
        hymonth: 0, //会员新增本月
        hyyear: 0, //会员新增本年
        sj: "",
        tqsrc: "",
        // 当地信息（城市、时间、地点、天气）
        local: {
          // ip地址所在城市
          city: '',
          // 所在城市温度
          temperature: '',
          // 天气类型
          type: '',
          // 时
          hour: '',
          // 分
          minute: '',
          // 月
          month: '',
          // 日
          date: '',
          // 星期几
          day: '',
          // 出勤率echart数据
        },
        //营业总额弹窗控制
        xszeDialogVisible: false,
        //营业总额弹窗loading
        xszeDialogLoading: false,
        //营业总额弹窗table高度
        xszeDialogTableheight: 465,
        //营业总额弹窗当前页
        xszeDialogCurrentPage: 1,
        //营业总额弹窗分页大小
        xszeDialogPageSize: 10,
        //总记录数
        xszeDialogTotal: 0,
        //营业总额弹窗数据
        xszeDialogTableData: [],
        nda: "",
        ndb: "",
        ndc: "",
        //按行业统计弹窗
        hyDialogVisible: false,
        //按行业统计弹窗数据
        hyDialogTableData: [],
        //按行业统计弹窗loading
        hyDialogLoading: false,
        //单位列表弹窗
        hydwDialogVisible: false,
        //单位列表弹窗数据
        hydwDialogTableData: [],
        //单位列表弹窗loading
        hydwDialogLoading: false,
        //单位列表弹窗table高度
        hydwDialogTableheight: 465,
        //单位列表弹窗当前页
        hydwDialogCurrentPage: 1,
        //单位列表弹窗分页大小
        hydwDialogPageSize: 10,
        //总记录数
        hydwDialogTotal: 0,
        //单位列表弹窗
        hydwdtDialogVisible: false,
        //单位列表弹窗数据
        hydwdtDialogTableData: [],
        //单位列表弹窗loading
        hydwdtDialogLoading: false,
        //单位列表弹窗table高度
        hydwdtDialogTableheight: 465,
        //单位列表弹窗当前页
        hydwdtDialogCurrentPage: 1,
        //单位列表弹窗分页大小
        hydwdtDialogPageSize: 10,
        //总记录数
        hydwdtDialogTotal: 0,
        //个人列表弹窗数据
        hygrdtDialogTableData: [],
        //个人列表弹窗loading
        hygrdtDialogLoading: false,
        //个人列表弹窗table高度
        hygrdtDialogTableheight: 465,
        //个人列表弹窗当前页
        hygrdtDialogCurrentPage: 1,
        //个人列表弹窗分页大小
        hygrdtDialogPageSize: 10,
        //个人总记录数
        hygrdtDialogTotal: 0,
        hylxData: {},
        hylx: "10",
        dwfl: "",
        sheng: "",
      }
    },
    //实现窗口自适应 add by yushch 20191227
    mounted() {
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      if (htmlWidth > 1500) {
        let htmlDom = document.getElementsByTagName('html')[0];
        //设置html的font-size
        htmlDom.style.fontSize = htmlWidth / 120 + 'px';
        window.addEventListener('resize', (e) => {
          let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
          //获取htmlDom
          let htmlDom = document.getElementsByTagName('html')[0];
          //设置html的font-size
          htmlDom.style.fontSize = htmlWidth / 120 + 'px';
        })
      }
      this.getDwCount()
      this.getGrCount()
      this.getTgCount()
      // this.getXzData()
      this.getTopData()
      this.getHyData()
      this.getLmData()
      this.getHyData()
      this.getHyqtData()
      this.getXzWeekData()
      this.getXzMonthData()
      this.getXzYearData();
      this.getDzData()
      this.getSjData()
      this.day_init()
      this.getLocalCity()
      this.getHylxData()
    },
    created() {
      if (this.CONSTANT.currentUser.deptid != null &&
        (this.CONSTANT.currentUser.deptid != '3' && this.CONSTANT.currentUser.deptid != '4' && this.CONSTANT.currentUser.deptid != '5' && this.CONSTANT.currentUser.deptid != '99')) {
          this.$router.push({ path: '/home' });
      }
    },
    methods: {
      getHylxData: function() {
        let vm = this;
        vm.$axios.get("/codelist/getCodetype/HYLX").then(
          function(res) {
            vm.hylxData = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      xtrkClick: function() {
        if(this.CONSTANT.currentUser.deptid != null && (this.CONSTANT.currentUser.deptid == '3' || this.CONSTANT.currentUser.deptid == '4')){
          this.$router.push({ path: '/member/hydw/hydwtj' });
        }else{
          this.$router.push({ path: '/home'});
        }
        
      },
      xsphClick: function() {
        this.$router.push({
          path: '/member/hydw/hydwtj'
        });
      },
      getLocalCity() {
        var data = {
          key: 'ZQKBZ-3FPR2-2IDUT-CPHHT-25LP6-KLF47', //申请的密钥,写死就行
        }
        var url = 'https://apis.map.qq.com/ws/location/v1/ip' //这个就是地理位置信息的接口
        data.output = 'jsonp'
        this.$jsonp(url, data)
          .then((res) => {
            this.local.city = res.result.ad_info.city
            // 根据城市，获取当前天气和时间（在此先预留获取天气方法，完成后取消注释）
            this.getLocalWeather(this.local.city)

          })
          .catch((error) => {
            console.log(error)
          })
      },
      getLocalWeather(city) {
        let vm = this;
        if (city != null || city != "") {
          var params = {
            city: city
          }
          vm.$axios.post("/home/getW", params).then(
            function(res) {
              let result = res.data.result;
              let w = JSON.parse(result)
              // 获取当天数据
              let todayWeather = w.data.forecast[0]
              if (todayWeather !== '') {
                // 获取温度，取平均值
                let high = todayWeather.high.split(' ')[1].slice(0, -1)
                let low = todayWeather.low.split(' ')[1].slice(0, -1)
                this.local.temperature = high + "℃" + "~" + low + "℃"
                // 获取天气类型
                this.local.type = todayWeather.type
                // 获取星期几
                this.local.day = todayWeather.date.slice(-3)
                // 获取当前时间
                let newDate = new Date()
                this.local.hour = newDate.getHours()
                this.local.minute = newDate.getMinutes()
                this.local.month = newDate.getMonth() + 1
                this.local.date = newDate.getDate()

                if (this.local.type == "晴") {
                  this.tqsrc = "../../../static/images/home/icn_sunny.png"
                } else if (this.local.type == "多云" || this.local.type == "霾") {
                  this.tqsrc = "../../../static/images/home/icn_overcast.png"
                } else if (this.local.type == "小雨" || this.local.type == "中雨" || this.local.type == "大雨") {
                  this.tqsrc = "../../../static/images/home/icn_rain.png"
                } else if (this.local.type == "雨夹雪") {
                  this.tqsrc = "../../../static/images/home/iicn_sleet.png"
                } else if (this.local.type == "小雪" || this.local.type == "中雪" || this.local.type == "大雪") {
                  this.tqsrc = "../../../static/images/home/icn_snow.png"
                } else if (this.local.type == "雷阵雨") {
                  this.tqsrc = "../../../static/images/home/icn_thunder.png"
                }
              }



            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
        }

      },

      getDzData: function() {
        var Ip = returnCitySN['cip']
        var cityname = returnCitySN['cname']
      },
      getSjData: function() {
        var date = new Date();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        this.sj = date.getFullYear() + "年" + month + "月" + strDate + "日";
      },
      //实现自适应
      day_init() {
        const self = this; //因为箭头函数会改变this指向，指向windows。所以先把this保存
        var todaypieId2 = document.getElementById("pieone");
        var todaypieId3 = document.getElementById("pie5");
        var todaypieId4 = document.getElementById("zhu");
        var todaypieId5 = document.getElementById("regionCharts");
        setTimeout(() => {
          window.onresize = function() {
            self.chart_today = echarts.init(
              todaypieId2
            );
            self.chart_today.resize();
            self.chart_today = echarts.init(
              todaypieId3
            );
            self.chart_today.resize();
            self.chart_today = echarts.init(
              todaypieId4
            );
            self.chart_today.resize();
            self.chart_today = echarts.init(
              todaypieId5
            );
            self.chart_today.resize();
          };
        }, 20);
      },
      //获取单位会员总数
      getDwCount: function() {
        let vm = this;
        var params = {
          sjzt: "11",
          hyztList: ["1", "2", "3"]
        }
        vm.$axios.post("/home/doSearchDwCount", params).then(function(res) {
            vm.hydws = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取个人会员总数
      getGrCount: function() {
        let vm = this;
        var params = {
          //sjzt: "08",
          sjzt: "11",
          hyztList: ["1", "2", "3"]
        }
        vm.$axios.post("/home/doSearchGrCount", params).then(
          function(res) {
            vm.hygrs = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取在线投稿总数
      getTgCount: function() {
        let vm = this;
        var params = {}
        vm.$axios.post("/home/doSearchTgCount", params).then(
          function(res) {
            vm.zxtgs = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },

      //获取Top7的单位排行数据
      getTopData: function() {
        let vm = this;
        var params = {
          pageSize: 7,
          pageNum: 1,
        };
        vm.$axios.post('/hydw/doSearchListByXsze', params).then(function(res) {
          this.topdata = res.data.result.list;
          this.nd = this.topdata[0].nda
          for (let i in this.topdata) {

            if (this.topdata[i].ayear == null) {
              this.topdata[i].ayear = 0
            }
          }
        }.bind(vm), function(error) {
          vm.loading = false;
          console.log(error);
        });
      },
      //按照行业统计会员单位销售额
      getHyData: function() {
        let vm = this
        var params = {};
        vm.$axios.post('/home/doSearchXsze', params).then(function(res) {
          this.hydata = res.data.result;
          this.barChart1()
        }.bind(vm), function(error) {
          vm.loading = false;
          console.log(error);
        });
      },
      // 左侧柱状图
      barChart1: function() {
        var hy = [];
        var hysl = [];
        for (let i in this.hydata) {
          hy.push(this.hydata[i].codeName)
          hysl.push(this.hydata[i].hysl)
        }
        var myChart = echarts.init(document.getElementById('zhu'), 'infographic');
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            // top:'1%',
            left: '15%',
            right: '1%',
            bottom: '0%',
            containLabel: true
          },
          title: {
            text: '按照行业统计会员数量',
            textStyle: {
              //文字颜色
              color: '#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle: 'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight: 'bold',
              //字体系列
              fontFamily: 'sans-serif',
              //字体大小
              fontSize: 18
            }
          },
          xAxis: [{
            type: 'category',
            data: hy,
            axisLabel: {
              interval: 0,
              rotate: 45, //代表逆时针旋转45度
              color: '#fff'
            }
          }],
          yAxis: [{
            type: 'value',
            minInterval: 1,
            axisLabel: {
              interval: 0,
              rotate: 0, //代表逆时针旋转45度
              color: '#fff'
            }
          }],
          series: [{
            type: 'bar',
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#83bff6'
                },
                {
                  offset: 0.5,
                  color: '#188df0'
                },
                {
                  offset: 1,
                  color: '#188df0'
                }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#2378f7'
                  },
                  {
                    offset: 0.7,
                    color: '#2378f7'
                  },
                  {
                    offset: 1,
                    color: '#83bff6'
                  }
                ])
              }
            },
            data: hysl
          }],
        };
        myChart.setOption(option);
        // this.$nextTick(() => {
        //   myChart.resize() // 这里是为了解决，tab刷新的时候，图表不刷新的问题。
        // })
      },
      //按照栏目投稿量占比
      getLmData: function() {
        let vm = this
        var params = {};
        vm.$axios.post('/home/doSearchGjlmSl', params).then(function(res) {
          this.lmdata = res.data.result;
          this.barChart2()
        }.bind(vm), function(error) {
          vm.loading = false;
          console.log(error);
        });
      },
      // 环饼图
      barChart2: function() {
        var data = [];
        for (let i in this.lmdata) {
          var p = {
            value: this.lmdata[i].gjlxsl,
            name: this.lmdata[i].gjlxmc
          }
          data.push(p)
        }
        var myChart = echarts.init(document.getElementById('pie5'), 'infographic');
        var option = {
          tooltip: {
            trigger: 'item'
          },
          title: {
            text: '按照栏目投稿量占比',
            textStyle: {
              //文字颜色
              color: '#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle: 'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight: 'bold',
              //字体系列
              fontFamily: 'sans-serif',
              //字体大小
              fontSize: 18
            },

          },
          grid: {
            top: '1%',
            left: '1%',
            right: '1%',
            bottom: '0%',
            containLabel: true
          },
          legend: {
            orient: 'vertical',
            top: '30%',
            right: '7%',
            textStyle: { //图例文字的样式
              color: '#ffffff',
              fontSize: 14
            },
          },
          series: [{
            name: 'Access From',
            type: 'pie',
            radius: ['45%', '70%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }],
          color: ['#29bb9d', '#fdc107', '#ff6364', '#346cfa', '#fc8452']
        };
        myChart.setOption(option);
      },
      //获取会员分布
      getHyqtData: function() {
        let vm = this
        var params = {};
        vm.$axios.post('/home/doSearchHyqt', params).then(function(res) {
          this.hyfbdata = res.data.result;
          this.initEchartMap();
        }.bind(vm), function(error) {
          vm.loading = false;
          console.log(error);
        });
      },
      //初始化中国地图
      initEchartMap() {
        var data = [];
        for (let i in this.hyfbdata) {
          if (this.hyfbdata[i].shengmc == "内蒙古自治区" ||
            this.hyfbdata[i].shengmc == "黑龙江省") {
            this.hyfbdata[i].shengmc = this.hyfbdata[i].shengmc.slice(0, 3)
          } else {
            this.hyfbdata[i].shengmc = this.hyfbdata[i].shengmc.slice(0, 2)
          }
          var p = {
            name: this.hyfbdata[i].shengmc,
            value: this.hyfbdata[i].hysl - 0,
            sheng: this.hyfbdata[i].sheng
          }
          data.push(p)
        }
        var dataList = data // 该数据是从服务器获取到的数据
        var option = {
          tooltip: {
            trigger: 'item',
            formatter: function(params) {

              if (params.value == params.value) {
                return params.value; //自行定义formatter格式
              } else {

                return "0";
              }

            }
          },
          title: {
            text: '消防协会会员区域分布展现',
            textStyle: {
              //文字颜色
              color: '#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle: 'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight: 'bold',
              //字体系列
              fontFamily: 'sans-serif',
              //字体大小
              fontSize: 20
            },
            left: 'center',
            top: "5%"
          },
          visualMap: {
            min: 0,
            max: 1000,
            left: '10%',
            textStyle: {
              color: '#ffffff',
              fontSize: 14
            },
            top: 'bottom',
            text: ['1000', '0'], //取值范围的文字
            inRange: {
              color: ['rgba(255, 100, 100, 0.3)', 'rgba(255, 100, 100, 1)'] //取值范围的颜色
            },
            show: true //图注
          },
          geo: {
            map: 'china',
            roam: false, //不开启缩放和平移
            zoom: 1.23, //视角缩放比例
            label: {
              normal: {
                show: true,
                fontSize: '10',
                color: '#fff'
              },
              emphasis: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            itemStyle: {
              normal: {
                borderWidth: .5, //区域边框宽度
                borderColor: '#ffffff', //区域边框颜色
                areaColor: "rgba(255, 255, 255, 0.2)", //区域颜色
              },
              emphasis: {
                areaColor: 'rgba(255, 100, 100, 1)', //鼠标选择区域颜色
                // shadowOffsetX: 0,
                // shadowOffsetY: 0,
                // shadowBlur: 5,
                // showBackground:'#fff',
                borderWidth: 0,
                borderColor: 'rgba(255, 255, 255, 0)', //区域边框颜色
              }
            }
          },
          series: [{
            name: '信息量',
            type: 'map',
            geoIndex: 0,
            data: dataList
          }]
        }

        var myChart = echarts.init(document.getElementById('regionCharts'));

        myChart.setOption(option)
        myChart.on('click', (params) => {
          // 在用户点击后控制台打印数据的名称
          // console.log(params);
          this.showHydwdtDialog(params.data.sheng)
        });
        this.$nextTick(() => {
          myChart.resize() // 这里是为了解决，tab刷新的时候，图表不刷新的问题。
        })

      },



      // 环饼图
      binChart1: function() {
        var data = [];
        var d = {
          name: "单位会员",
          value: this.hydws
        }
        data.push(d)
        var d2 = {
          name: "个人会员",
          value: this.hygrs
        }
        data.push(d2)

        var myChart = echarts.init(document.getElementById('pieone'), 'infographic');
        var option = {
          tooltip: {
            trigger: 'item'
          },
          title: {
            text: '新增会员统计',
            textStyle: {
              //文字颜色
              color: '#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle: 'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight: 'bold',
              //字体系列
              fontFamily: 'sans-serif',
              //字体大小
              fontSize: 18
            },

          },
          grid: {
            top: '1%',
            left: '1%',
            right: '1%',
            bottom: '0%',
            containLabel: true
          },
          legend: {
            orient: 'vertical',
            top: '80%',
            left: '10%',
            textStyle: { //图例文字的样式
              color: '#ffffff',
              fontSize: 14
            },

          },
          series: [{
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['40%', '45%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }],
          color: ['#29bb9d', '#ff6364']
        };
        myChart.setOption(option);
      },

      //获取本周新增会员数据
      getXzWeekData: function() {
        let vm = this;
        var params = {}
        vm.$axios.post("/home/doSearchWeek", params).then(
          function(res) {
            vm.hyweek = res.data.result / 30 * 100;
            this.format1(vm.hyweek)
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      format1(percentage) {
        return percentage === 30 ? '满' : `30`;
      },
      //获取本月新增会员数据
      getXzMonthData: function() {
        let vm = this;
        var params = {}
        vm.$axios.post("/home/doSearchMonth", params).then(
          function(res) {
            vm.hymonth = res.data.result / 100 * 100;
            this.format2(vm.hymonth)
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      format2(percentage) {
        return percentage === 100 ? '满' : `100`;
      },
      //获取本年新增会员数据
      getXzYearData: function() {
        let vm = this;
        var params = {}
        vm.$axios.post("/home/doSearchYear", params).then(
          function(res) {
            vm.hyyear = res.data.result / 1000 * 100;
            this.format3(vm.hyyear)
            this.binChart1()
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      format3(percentage) {

        return percentage === 1000 ? '满' : `1000`;
      },
      showXszeDialog() {
        this.searchXszeDialogClick();
        this.xszeDialogVisible = true;
      },
      searchXszeDialogClick: function(type) {
        let vm = this;
        //按钮事件的选择
        if (type == "page") {
          vm.xszeDialogTableData = [];
        } else {
          vm.xszeDialogCurrentPage = 1;
        }
        vm.xszeDialogLoading = true; //表格重新加载
        var params = {
          pageSize: vm.xszeDialogPageSize,
          pageNum: vm.xszeDialogCurrentPage,
        };
        vm.$axios.post('/hydw/doSearchListByXsze', params).then(function(res) {
          var tableTemp = new Array((this.xszeDialogCurrentPage - 1) * this.xszeDialogPageSize);
          this.xszeDialogTableData = tableTemp.concat(res.data.result.list);
          if(vm.xszeDialogCurrentPage == "1"){
            this.nda = this.xszeDialogTableData[0].nda + "年度销售额"
            this.ndb = this.xszeDialogTableData[0].ndb + "年度销售额"
            this.ndc = this.xszeDialogTableData[0].ndc + "年度销售额"
          }

          this.xszeDialogTotal = res.data.result.total;
          this.xszeDialogLoading = false;
        }.bind(vm), function(error) {
          vm.xszeDialogLoading = false;
          console.log(error);
        });
      },
      //弹窗分页
      dialogCurrentPageChange: function(val) {
        if (this.xszeDialogCurrentPage != val) {
          this.xszeDialogCurrentPage = val;
          this.searchXszeDialogClick('page');
        }
      },
      //弹窗分页
      dialogPageSizeChange: function(val) {
        this.xszeDialogPageSize = val;
        this.searchXszeDialogClick('page');
      },
      //按行业统计弹窗
      showHyDialog() {
        this.searchHyDialogClick();
        this.hyDialogVisible = true;
      },
      searchHyDialogClick() {
        let vm = this;
        vm.hyDialogTableData = [];
        vm.hyDialogLoading = true; //表格重新加载
        var params = {

        };
        vm.$axios.post('/hydw/doSearchListByHy', params).then(function(res) {
          this.hyDialogTableData = res.data.result;
          this.hyDialogLoading = false;
        }.bind(vm), function(error) {
          vm.hyDialogLoading = false;
          console.log(error);
        });
      },
      //单位列表弹窗
      showHydwdtDialog(sheng) {
        this.hylx = "10"
        this.sheng = sheng
        this.searchHydwdtDialogClick("");
        this.searchHygrdtDialogClick("");
        this.hydwdtDialogVisible = true;
      },
      searchHydwdtDialogClick: function(type) {
        let vm = this;
        //按钮事件的选择
        if (type == "page") {
          vm.hydwdtDialogTableData = [];
        } else {
          vm.hydwdtDialogCurrentPage = 1;
        }
        vm.hydwdtDialogLoading = true; //表格重新加载
        var params = {
          sheng: vm.sheng,
          pageSize: vm.hydwdtDialogPageSize,
          pageNum: vm.hydwdtDialogCurrentPage,
        };
        vm.$axios.post('/home/doSearchHyqtDWList', params).then(function(res) {
          var tableTemp = new Array((this.hydwdtDialogCurrentPage - 1) * this.hydwdtDialogPageSize);
          this.hydwdtDialogTableData = tableTemp.concat(res.data.result.list);
          this.hydwdtDialogTotal = res.data.result.total;
          this.hydwdtDialogLoading = false;
        }.bind(vm), function(error) {
          vm.hydwdtDialogLoading = false;
          console.log(error);
        });
      },
      //弹窗分页
      dialoghydwdtCurrentPageChange: function(val) {
        if (this.hydwdtDialogCurrentPage != val) {
          this.hydwdtDialogCurrentPage = val;
          this.searchHydwdtDialogClick('page');
        }
      },
      //弹窗分页
      dialoghydwdtPageSizeChange: function(val) {
        this.hydwdtDialogPageSize = val;
        this.searchHydwdtDialogClick('page');
      },
      searchHygrdtDialogClick: function(type) {
        let vm = this;
        //按钮事件的选择
        if (type == "page") {
          vm.hygrdtDialogTableData = [];
        } else {
          vm.hygrdtDialogCurrentPage = 1;
        }
        vm.hygrdtDialogLoading = true; //表格重新加载
        var params = {
          sheng: vm.sheng,
          pageSize: vm.hygrdtDialogPageSize,
          pageNum: vm.hygrdtDialogCurrentPage,
        };
        vm.$axios.post('/home/doSearchHyqtGrList', params).then(function(res) {
          var tableTemp = new Array((this.hygrdtDialogCurrentPage - 1) * this.hygrdtDialogPageSize);
          this.hygrdtDialogTableData = tableTemp.concat(res.data.result.list);
          this.hygrdtDialogTotal = res.data.result.total;
          this.hygrdtDialogLoading = false;
        }.bind(vm), function(error) {
          vm.hygrdtDialogLoading = false;
          console.log(error);
        });
      },
      //弹窗分页
      dialoghygrdtCurrentPageChange: function(val) {
        if (this.hygrdtDialogCurrentPage != val) {
          this.hygrdtDialogCurrentPage = val;
          this.searchHygrdtDialogClick('page');
        }
      },
      //弹窗分页
      dialoghygrdtPageSizeChange: function(val) {
        this.hygrdtDialogPageSize = val;
        this.searchHygrdtDialogClick('page');
      },

      //单位列表弹窗
      showHydwDialog(dwfl) {
        this.dwfl = dwfl;
        this.searchHydwDialogClick('click');
        this.hydwDialogVisible = true;
      },
      searchHydwDialogClick(type) {
        let vm = this;
        //按钮事件的选择
        if (type == "page") {
          vm.hydwDialogTableData = [];
        } else {
          vm.hydwDialogCurrentPage = 1;
        }
        vm.hydwDialogLoading = true; //表格重新加载
        var params = {
          dwfl: vm.dwfl,
          pageSize: vm.hydwDialogPageSize,
          pageNum: vm.hydwDialogCurrentPage,
        };
        vm.$axios.post('/home/doSearchHydw', params).then(function(res) {
          var tableTemp = new Array((this.hydwDialogCurrentPage - 1) * this.hydwDialogPageSize);
          this.hydwDialogTableData = tableTemp.concat(res.data.result.list);
          this.hydwDialogTotal = res.data.result.total
          this.hydwDialogLoading = false;
        }.bind(vm), function(error) {
          vm.hyDialogLoading = false;
          console.log(error);
        });
      },
      //弹窗分页
      dialoghydwCurrentPageChange: function(val) {
        if (this.hydwDialogCurrentPage != val) {
          this.hydwDialogCurrentPage = val;
          this.searchHydwDialogClick('page');
        }
      },
      //弹窗分页
      dialoghydwPageSizeChange: function(val) {
        this.hydwDialogPageSize = val;
        this.searchHydwDialogClick('page');
      },
      dwDetail: function(dwid) {
        this.$router.push({
          name: "member/hydwcertificate/HydwDetail",
          query: {
            dwid: dwid,
            type: 'adminEdit'
          }
        })
      },
      grDetail: function(grid) {
        this.$router.push({
          name: "member/hygrcertificate/HygrDetail",
          query: {
            grid: grid,
            type: 'adminEdit'
          }
        })
      },
    }
  };
</script>

<style lang="scss">
  @font-face {
    font-family: 'PingFangRegular';
    src: url(../../../static/fonts/iconfont/PingFangRegular.ttf);
  }

  @font-face {
    font-family: 'SourceHanSansSCReqular';
    src: url(../../../static/fonts/iconfont/SourceHanSansSC-Regular.otf);
  }

  #homebig {
    min-height: 930px;
    min-width: 1628px;
    // width: 100vw;
    height: 100vh;
    background-repeat: repeat;

    //mofify by yushch
    background: url(../../../static/images/home/pic_bg_big.png);
    background-size: cover;

    .bt {
      width: 100%;
      text-align: center;
      position: absolute;
    }

    .znr_head {
      height: 5rem;
      width: 100%;
      background: #001334;
    }

    .ts {
      display: inline-block;
      width: 50%;
      font-size: 1rem;
      color: #FFFFFF;
      margin-left: 0.9375rem;
    }

    .ts_dz {
      display: inline-block;
      line-height: 5rem;
      vertical-align: middle;
      margin-right: 0.625rem;
    }

    .ts_tq {
      display: inline-block;
      margin-right: 0.625rem;

    }

    .tq_img {
      vertical-align: middle;
      margin-top: -0.1875rem;
      width: 1.5625rem;
      height: 1.5625rem;
      margin-right: 0.3125rem;
    }

    .tq_txt {
      line-height: 5rem;
      vertical-align: middle;
    }

    .ts_sj {
      display: inline-block;
      width: 8.75rem;
      line-height: 5rem;
      vertical-align: middle;
    }

    .xtrk {
      display: inline-block;
      position: absolute;
      height: 5rem;
      line-height: 5rem;
      vertical-align: middle;
      right: 0;
      margin-right: 0.9375rem;
      cursor: pointer;
    }

    .xtrk_txt {
      display: inline-block;
      font-size: 1.125rem;
      color: #6FD3DB;
    }

    .xtrk_img {
      display: inline-block;
      width: 2.5rem;
      height: 1.5rem;
      vertical-align: middle;
      margin-top: -0.5rem;

    }

    .znr_body {
      padding: 3rem 1.25rem 0rem 1.25rem;
      height: calc(100% - 5rem);
    }

    .body_head {
      height: 9.375rem;
      width: 100%;
      position: relative;
    }

    .header_line {
      width: calc(25% - 0.7rem);
      height: 9.375rem;
      margin-right: 0.625rem;
      background-color: rgba(255, 255, 255, 0.2);
      display: inline-block;
      border-top: 1px solid #0076e4;
    }

    .header_line:last-child {
      margin-right: 0rem;

    }

    .head_img {
      display: inline-block;
      vertical-align: top;
      margin-left: 2rem;
      margin-top: 1.125rem;
      width: 7rem;
      height: 7rem;
    }

    .txt {
      display: inline-block;
      margin-left: 1rem;
      margin-top: 1.125rem;
      color: #FFFFFF;
      width: 10rem;

    }

    .txt_title {
      display: block;
      height: 3rem;
      font-size: 1.375rem;
      line-height: 3rem;
      vertical-align: middle;
    }

    .sl {
      display: block;
      height: 3rem;
      line-height: 3rem;
      vertical-align: middle;
      font-size: 2.25rem;
    }

    .line_left {
      position: absolute;
      width: 1.25rem;
      height: 1px;
      background: #3bd3ff;
    }

    .line_right {
      float: right;
      width: 1.25rem;
      height: 1px;
      background: #3bd3ff;
    }

    .body_left {
      display: inline-block;
      width: calc(25% - 0.7rem);
      float: left;
      margin-top: 1.25rem;
      margin-right: 0.9375rem;
    }

    .body_right {
      display: inline-block;
      width: calc(25% - 0.7rem);
      float: right;
      margin-top: 1.25rem;
      margin-right: 0.3125rem;
    }

    .left_one {
      width: 100%;
      background-color: rgba(255, 255, 255, 0.2);
      height: 19rem;
      border-top: 1px solid #0076e4;
    }

    .left_one_div {
      width: 100%;
      padding: 0.625rem;
      color: #FFFFFF;
      height: 18.75rem;
    }

    .left_one_head {
      width: 100%;
      height: 2.5rem;
      font-size: 1.125rem;
      font-weight: bold;
    }

    .left_one_nr_bt {
      width: 100%;
      text-align: center;
      font-size: 1rem;
      height: 1.875rem;
    }

    .left_one_nr {
      width: 100%;
      text-align: center;
      height: 1.875rem;
      list-style: none;
      font-size: 0.75rem;
    }

    .left_one_nr:nth-child(1) {
      color: #ff6364;
    }

    .left_one_nr:nth-child(2) {
      color: #FDC107;
    }

    .left_one_nr:nth-child(3) {
      color: #29bb9d;
    }


    .left_one_pm {
      display: inline-block;
      width: 12%;
      white-space: nowrap;
      /*强制span不换行*/
      overflow: hidden;
      /*超出宽度部分隐藏*/
      text-overflow: ellipsis;
      /*超出部分以点号代替*/
    }

    .left_one_dw {
      display: inline-block;
      width: 55%;
      white-space: nowrap;
      /*强制span不换行*/
      overflow: hidden;
      /*超出宽度部分隐藏*/
      text-overflow: ellipsis;
      /*超出部分以点号代替*/
    }

    .left_one_xsze {
      display: inline-block;
      width: 30%;
      white-space: nowrap;
      /*强制span不换行*/
      overflow: hidden;
      /*超出宽度部分隐藏*/
      text-overflow: ellipsis;
      /*超出部分以点号代替*/
    }

    .left_two {
      margin-top: 1.25rem;
      width: 100%;
      background-color: rgba(255, 255, 255, 0.2);
      height: 19rem;
      border-top: 1px solid #0076e4;
    }

    .left_two_left {
      width: 42%;
      display: inline-block;
      vertical-align: top;
    }

    .pieone {
      width: 100%;
      height: 17.25rem;
    }

    .left_two_right {
      width: 57%;
      display: inline-block;
    }

    .left_two_div {
      margin-top: 5.5rem;
    }

    .progress_div {
      width: 100%;
      height: 3.125rem;
    }

    .progress_bt {
      display: inline-block;
      width: 3rem;
      font-size: 0.875rem;
    }

    .progress_zj {
      display: inline-block;
      width: calc(100% - 3.75rem);
      // margin-left: 3.75rem;
    }

    .el-progress-bar {
      // width: 50%;
    }

    .el-progress__text {
      color: #FFFFFF;
      margin-left: 11% !important;
    }

    .el-progress-bar__outer {
      width: 110% !important;
      height: 12px !important;
      border: 1px solid #3bd3ff !important;
      background-color: #263340 !important;
    }

    .el-progress-bar__inner {
      background: #3bd3ff !important;
    }


    .right_one {
      width: 100%;
      background-color: rgba(255, 255, 255, 0.2);
      height: 19rem;
      border-top: 1px solid #0076e4;
    }

    .echartsBox {
      width: 100%;
      height: 100%;
      border: none;
      padding-top: 0px !important;
      margin-top: 0px !important;
      padding-left: 0px !important;
      margin-left: 0px !important;
    }

    .zhu {
      height: 17.8125rem !important;
      width: 100%;
      cursor: pointer;
    }

    .right_two {
      margin-top: 1.25rem;
      width: 100%;
      background-color: rgba(255, 255, 255, 0.2);
      height: 19rem;
      border-top: 1px solid #0076e4;
    }

    .pie5 {
      height: 17rem !important;
      width: 100%;
    }

    .body_center {
      display: inline-block;
      width: calc(50% - 0.625rem);
      // background: #F7F7F7;
      margin-top: 1.25rem;
      height: 39.25rem;
    }

    .china_map_box {
      width: 100%;
      height: 39.25rem;
    }

    .china_map {
      width: 100%;
      height: 39.25rem;
    }

    .el-dialog__header {
      text-align: center;
    }

    .el-table__header,
    .el-table__body {
      width: 100% !important;
    }

    .el-table__header th,
    .el-table__header tr {
      background-color: #113eab;
      color: #fff;
    }

    .el-dialog__title {
      font-weight: 900;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/homeBig.vue